import styled, { keyframes } from "styled-components";

const fadeUpIn = keyframes`
     0% {
        opacity: 0;
        transform: translateY(15px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

export const Container = styled.div<{ showTimer?: boolean }>(({ theme, showTimer }) => ({
    flex: 1,
    marginRight: showTimer ? theme.spacing.xxSmall : theme.spacing.xLarge,
    position: "relative",
}));

export const CroutonText = styled.div`
    animation: ${fadeUpIn} 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;
